import {useCallback, useEffect, useState, useContext} from "react";
import CountryContext from "../CountryContext";
import useCountryAxiosInstance from "./useCountryAxiosInstance";
import {NotificationsContext} from "../ui-components/Notifications";
import {useIntl} from "react-intl";




export const useServicesSurveys = (worksite_id) => {
	const intl = useIntl();
	const {country} = useContext(CountryContext);
	const countryApiRequest = useCountryAxiosInstance(country?.code);
	const {push} = useContext(NotificationsContext);

	const [servicesSurveys, setServicesSurveys] = useState([]);

	const fetchServicesSurveys = useCallback(async () => {
		try {
		// fetch surveys
		const res = await countryApiRequest.get(
			`/service_surveys/by_worksite/${worksite_id}`,
			{params: {join: "services"}}
		);
		setServicesSurveys(res);

		} catch (error) {
			push({type: 'error', title: intl.formatMessage({id: 'server_error'})});
		}
	}, [countryApiRequest, worksite_id]);

	useEffect(() => {
		fetchServicesSurveys();
	}, []);

	return {servicesSurveys, fetchServicesSurveys};

}